import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCROLL_TARGETS = ["#kt_content", "#kt_wrapper", ".wrapper", ".App"];

/**
 * Reset scroll to top whenever the route pathname changes.
 * Covers window scroll and common dashboard content containers.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    SCROLL_TARGETS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (el instanceof HTMLElement && el.scrollTop > 0) {
          el.scrollTop = 0;
        }
      });
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
